var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-leading-normal",attrs:{"data-cy":"leave-date"}},[_vm._v(" "+_vm._s(_vm.leaveDate)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }